module.exports = __webpack_public_path__ + "static/media/rule.7b58c825.svg";